// components/BillingCard.tsx
import React from "react";
import styles from "./Accordion.module.css";
import CardWrapper from "../CardWrapper";

interface BillingItem {
  label?: string;
  value?: string | number | null;
}

interface BillingCardProps {
  title: string;
  data: BillingItem[];
  columns?: number;
  rtmStatus?: "Active" | "Inactive" | "Pending";
}

const BillingCard: React.FC<BillingCardProps> = ({
  title,
  data,
  columns = 3,
  rtmStatus,
}) => {
  return (
    <div
      title={
        rtmStatus === "Inactive"
          ? "Patient is inactive"
          : rtmStatus === "Pending"
          ? "Patient is pending"
          : undefined
      }
    >
      <CardWrapper customStyle={{ padding: "1.2rem" }}>
        <div
          className={styles.grid}
          style={{ gridTemplateColumns: `repeat(${columns}, minmax(0, 1fr))` }}
        >
          <p className={styles.title}>{title}</p>
          {data.map((item, index) => {
            let displayLabel = item.label || "";
            let displayValue = item.value;

            if (displayLabel.toLowerCase().includes("time spent")) {
              if (displayValue === "-") {
              } else {
                let minutesToDisplay;
                if (
                  typeof displayValue === "string" &&
                  displayValue.includes("/")
                ) {
                  const parts = displayValue.split("/");
                  minutesToDisplay = Number(parts[0]);
                } else {
                  minutesToDisplay = Number(displayValue);
                }

                if (isNaN(minutesToDisplay) || minutesToDisplay === 0) {
                  displayValue = "00 mins";
                } else {
                  displayValue = `${minutesToDisplay} mins`;
                }
              }
            }

            if (
              displayLabel.toLowerCase().includes("billable on") &&
              typeof displayValue === "string" &&
              !displayValue.includes("mins")
            ) {
              const date = new Date(displayValue);
              if (!isNaN(date.getTime())) {
                const formattedDate = date.toLocaleDateString("en-US", {
                  month: "2-digit",
                  day: "2-digit",
                  year: "numeric",
                });

                displayLabel = `${displayLabel}`;
                displayValue = formattedDate;
              }
            }

            return (
              <div key={index} className={styles.box}>
                <p className={styles.billLabel}>{displayLabel}</p>
                <p
                  className={
                    displayLabel.toLowerCase().includes("billable on")
                      ? styles.billableDate
                      : styles.billValue
                  }
                >
                  {displayValue}
                </p>
              </div>
            );
          })}
        </div>
      </CardWrapper>
    </div>
  );
};

export default BillingCard;
